<i18n>
{
  "fr": {
    "opacity": "Opacité",
    "time": "Sélection temporelle",
    "legend-label": "Légende",
    "opacity-label": "Opacité",
    "delete-label": "Supprimer",
    "layer-list-label": "Liste des couches",
    "show-hide-label": "Afficher / masquer",
    "group-filter": "Filtre par zone d'intérêt",
    "group-filter-all": "Tout afficher",
    "group-filter-selected": "Filtre:",
    "options": "Options"
  },
  "de": {

  }
}
</i18n>

<template>
  <div :class="['layer-item md-elevation-2', { disabled: disabled }]">
    <div class="header" @click="toggleSelected()">
      <div class="icon">
        <GeomTypeIcon class="geom-type-icon" :geomType="layer.geomType" />
      </div>
      <div class="md-title">
        {{ layer.metadata.name }}
      </div>
      <div class="button-container">
        <md-button
          :class="['md-icon-button md-dense', { 'md-primary': showOnMap }]"
          @click.stop="clickShowHide"
        >
          <md-icon>remove_red_eye</md-icon>
          <md-tooltip md-direction="bottom">{{
            $t("show-hide-label")
          }}</md-tooltip>
        </md-button>
      </div>
    </div>
    <div class="options" v-on:click.stop>
      <div class="options-header" @click="showOptions = !showOptions">
        <md-icon v-if="showOptions">keyboard_arrow_up</md-icon>
        <md-icon v-if="!showOptions">keyboard_arrow_down</md-icon>
        {{ $t("options") }}
      </div>
      <div class="options-content" v-if="showOptions">
        <div class="opacity-container option">
          <div class="opacity-content option-content">
            <span class="option-label">{{ $t("opacity") }}</span>
            <vue-slider
              v-model="manualOpacity"
              :min="0"
              :max="1"
              :interval="0.1"
              :contained="true"
            >
            </vue-slider>
          </div>
        </div>
        <div class="group-filter option" v-if="hasGroupFilter">
          <div class="option-content">
            <md-field md-dense class="select-group-filter">
              <label>{{ $t("group-filter") }}</label>
              <md-select v-model="selectedGroupFilterCode">
                <md-option value="all">{{ $t("group-filter-all") }}</md-option>
                <md-option
                  v-for="group in groupsFilter"
                  :key="group.id"
                  :value="group.code"
                  >{{ group.name[$i18n.locale] }}</md-option
                >
              </md-select>
            </md-field>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import GeomTypeIcon from "@/components/vue-map/common/geomTypeIcon";
import GroupProxy from "@/proxies/group";

import LayerStoreMixin from "@/mixins/store/layer";
import MapMixin from "@/mixins/store/map";
import _ from "lodash";
// import Config from '@/config.js'

export default {
  name: "LayerCard",
  mixins: [LayerStoreMixin, MapMixin],
  components: {
    GeomTypeIcon,
  },
  props: {
    layer: {
      type: Object,
      default: () => {
        return {};
      },
    },
    layerGroup: {
      type: Object,
      default: () => {
        return {};
      },
    },
    disabled: {
      type: Boolean,
      default: () => {
        return {};
      },
    },
  },
  data() {
    return {
      showOpacity: false,
      showLegend: false,
      manualOpacity: _.clone(this.layer.webviewConfig.opacity),
      showOnMap: _.clone(this.layer.webviewConfig.showOnMap),
      showGroupFilter: false,
      groupsFilter: [],
      selectedGroupFilterCode: "all",
      showOptions: false,
    };
  },
  computed: {
    isSelected() {
      return this.selectedLayers.includes(this.layer);
    },
    hasNoFocus() {
      return this.selectedLayers.length > 0 && !this.isSelected;
    },
    opacity() {
      // if (this.hasNoFocus) return Config.layerConfiguration.opacityWhenNotFocus
      return this.manualOpacity;
    },
    hasGroupFilter() {
      return typeof this.getGroupFilterInteraction !== "undefined";
    },
    getGroupFilterInteraction() {
      return this.layer.webviewConfig.availableInteractions.find(
        (interaction) => interaction.key === "GRP_FILTER"
      );
    },
    selectedGroupFilter() {
      if (this.selectedGroupFilterCode === "all") return null;
      return this.groupsFilter.find(
        (group) => group.code === this.selectedGroupFilterCode
      );
    },
  },
  watch: {
    opacity(val) {
      this.layer.setOpacity(val);
    },
    isSelected(val) {
      // if (val) this.manualOpacity = 1;
      if (val && !this.showOnMap) this.showOnMap = true;
    },
    showOnMap(val) {
      this.layer.setVisible(val);
    },
    selectedGroupFilterCode(val) {
      let currentParams = this.layer.getSource().getParams();
      if (val === "all") {
        currentParams.showAll = "TRUE";
        currentParams.groupCode = undefined;
      } else {
        currentParams.showAll = "FALSE";
        currentParams.groupCode = val;
      }
      this.layer.getSource().updateParams(currentParams);
      this.layer.fit(this.mapRef);
      this.setCurrentGeom(null);
      this.setCurrentObject({});
    }
  },
  mounted() {
    if (this.hasGroupFilter) this.fetchGroupFilter()
    this.layer.setVisible(this.showOnMap)
  },
  methods: {
    toggleOpacity() {
      this.showOpacity = !this.showOpacity;
    },
    clickShowHide() {
      this.showOnMap = !this.showOnMap;
    },
    toggleSelected() {
      this.toggleSelectedLayer(this.layer);
      if (this.isSelected) this.setLayerGroupInfo(this.layerGroup);
    },
    fetchGroupFilter() {
      GroupProxy.getByCode(this.getGroupFilterInteraction.params.groupCode)
        .then((group) => {
          this.groupsFilter = group.subGroups;
        })
        .catch(this.handleError);
    },
    handleError(e) {
      console.error(e);
    },
  },
};
</script>

<style lang="scss" scoped>
.layer-item {
  cursor: hand;
  background-color: white;
  padding: 7px;
  margin-top: 7px;
  margin-bottom: 7px;
  margin-left: 5px;
  margin-right: 5px;

  &.disabled {
    filter: saturate(0.2);
  }

  .options {
    cursor: pointer;
    color: rgba(0, 0, 0, 0.87);

    .options-content {
      margin-top: 2px;
      margin-bottom: 0px;
      padding-top: 5px;
      background-color: #fefefe;
      margin-left: 30px;
      padding-left: 6px;
      padding-right: 6px;
      border-left: 1px solid #00000033;
    }

    .option {
      padding: 1px;

      &.option:not(:last-of-type) {
        margin-bottom: 10px;
      }

      .option-content {
        display: flex;

        .option-label {
          min-width: 65px;
          font-size: 12px;
          color: rgba(0, 0, 0, 0.54);
          margin-left: -1px;
        }
      }
    }
  }

  &.selected {
    background-color: #184aa0;
    color: white;

    .options-header {
      color: white;

      .md-icon {
        color: white;
      }
    }
  }

  .header {
    display: grid;
    grid-template-areas: "icon title button";
    grid-template-columns: 20px auto auto;

    .icon {
      grid-area: icon;
    }

    .geom-type-icon {
      margin-left: 3px;
      margin-top: 4px;
    }

    .md-caption.time-info {
      display: block;
      margin-bottom: -10px;
    }

    .md-title {
      grid-area: title;
      margin-top: 5px;
      margin-left: 7px;
      font-size: 14px;
      line-height: 20px;
    }

    .button-container {
      grid-area: button;
      margin-left: auto;
    }

    .md-button {
      margin-right: 0px;
    }
  }

  .opacity-container {
    .option-content {
      margin-top: -3px;
    }
  }

  .group-filter {
    .select-group-filter {
      margin-top: -5px;
      margin-bottom: 0px;
    }
  }

  .time-player-icon {
    width: 18px;
    margin-left: -2px;
    float: left;

    .md-icon {
      font-size: 17px !important;
    }
  }

  .time-slider {
    width: calc(100% - 13px) !important;
    margin-left: 13px;
    padding-top: 2px;
  }

  .time-content {
    padding: 7px;
    background-color: #eff1ed;
  }

  .layer-list-container {
    margin-top: 5px;
    .layer-list-content {
      padding: 7px;
      background-color: #eff1ed;

      .layer-group-item {
        margin: 0;
        margin-top: 5px;
        margin-left: 5px;

        &.selected {
          font-weight: 600;
        }
      }
    }
  }

  .group-filter {
    .group-filter-header {
      .title {
        margin-left: 4px;
      }
    }
  }
}

.vue-slider {
  width: 100% !important;
}
</style>
